// const presenterList = {};
export function filterMeetingSchedule(worshipTime) {
    // if (worshipTime.id === "gospel-meeting" && !worshipTime.ignoreCountdown) {
    //     const presenter = worshipTime.presenter;
    //     presenterList[presenter] = presenters[presenter];
    //     return true;
    // }
    return worshipTime.id === "gospel-meeting" && !worshipTime.ignoreCountdown;
}
